import { FileText, Download, Users, TrendingUp } from "lucide-react"

interface ResourceStatsCardsProps {
  totalResources: number
  totalDownloads: number
  activeContributors: number
  resourcesThisMonth: number
}

export function ResourceStatsCards({
  totalResources,
  totalDownloads,
  activeContributors,
  resourcesThisMonth,
}: ResourceStatsCardsProps) {
  const stats = [
    {
      icon: <FileText className="w-6 h-6" />,
      label: "Total Resources",
      value: totalResources.toLocaleString(),
      bgColor: "bg-blue-50",
      iconColor: "text-blue-600",
    },
    {
      icon: <Download className="w-6 h-6" />,
      label: "Total Downloads",
      value: totalDownloads.toLocaleString(),
      bgColor: "bg-green-50",
      iconColor: "text-green-600",
    },
    {
      icon: <Users className="w-6 h-6" />,
      label: "Active Contributors",
      value: activeContributors.toLocaleString(),
      bgColor: "bg-purple-50",
      iconColor: "text-purple-600",
    },
    {
      icon: <TrendingUp className="w-6 h-6" />,
      label: "Resources This Month",
      value: resourcesThisMonth.toLocaleString(),
      bgColor: "bg-amber-50",
      iconColor: "text-amber-600",
    },
  ]

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
      {stats.map((stat, index) => (
        <div
          key={index}
          className="bg-white rounded-xl p-6 shadow-sm border border-gray-200 hover:shadow-md transition"
        >
          <div className="flex items-center gap-4">
            <div className={`${stat.bgColor} ${stat.iconColor} p-3 rounded-lg`}>{stat.icon}</div>
            <div>
              <p className="text-sm text-gray-600 mb-1">{stat.label}</p>
              <p className="text-2xl font-bold text-gray-900">{stat.value}</p>
            </div>
          </div>
        </div>
      ))}
    </div>
  )
}
